import styled from 'styled-components'

/**
 * export interface TimerProps {
 *   delayResend: number;
 * }
 */

const Timer = ({ delayResend }) => {
  const minutes = Math.floor(delayResend / 60)
  const seconds = Math.floor(delayResend % 60)

  const to2Digits = (val) => {
    return `${val}`.padStart(2, '0')
  }

  return (
    <Desc>
      {to2Digits(minutes)}:{to2Digits(seconds)}
    </Desc>
  )
}

const Desc = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #003cde;
  padding-top: 8px;
`

export default Timer
